import React, { createContext, useContext, useState } from "react";
import PlanAlert from "../components/PlanAlert";

// Create the context
const PlanAlertContext = createContext();

// Provider component
export function PlanAlertProvider({ children }) {
  const [alertState, setAlertState] = useState({
    isOpen: false,
    title: "",
    description: "",
    plan: null,
  });

  // Function to show the plan alert
  const showPlanAlert = ({ title, description, plan }) => {
    setAlertState({
      isOpen: true,
      title,
      description,
      plan,
    });
  };

  // Function to hide the plan alert
  const hidePlanAlert = () => {
    setAlertState((prevState) => ({
      ...prevState,
      isOpen: false,
    }));
  };

  return (
    <PlanAlertContext.Provider value={{ showPlanAlert }}>
      {children}
      {/* Render the PlanAlert component here, controlled by our state */}
      <PlanAlert
        isOpen={alertState.isOpen}
        title={alertState.title}
        description={alertState.description}
        plan={alertState.plan}
        onClose={hidePlanAlert}
      />
    </PlanAlertContext.Provider>
  );
}

// Custom hook to use the plan alert
export function usePlanAlert() {
  const context = useContext(PlanAlertContext);
  if (context === undefined) {
    throw new Error("usePlanAlert must be used within a PlanAlertProvider");
  }
  return context;
}
